import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getProductionPerformanceReport,
  type ProductionPerformanceReportResult,
} from '@services/api/reports/providerPerformance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type ProductionPerformanceFinanceData = ProductionPerformanceReportResult

export type UseProductionPerformanceFinanceResult = {
  loading: boolean
  error: string | null
  data: ProductionPerformanceFinanceData | null
  bucketLabel: string
}

export function useProductionPerformanceFinance(
  toolbarSelection: Record<string, string>,
): UseProductionPerformanceFinanceResult {
  const getBucketFromData = useCallback(
    (data: ProductionPerformanceReportResult): ReportBucketType =>
      data.production.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getProductionPerformanceReport,
    getBucketFromData,
    errorMessage: 'Failed to load production performance data',
  })
}
